/* eslint-disable */
<template>
  <div class="manage-case">
    <Navigation indexProps="3"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title">
          <h1 v-if="showContent">{{ isEdit ? 'case ' + singleCase.CaseID : 'Create case' }}</h1>
          <h5 v-else>Case does not exist</h5>
        </div>
        <div class="header-sub-title">A case allows you to keep track of all the assessments required for a particular
          matter.
        </div>
      </div>
    </div>
    <div class="panel">
      <CaseMenu :key="isEditId" :indexProps="isEdit ? '0' : '1'"/>
      <div class="content" v-if="showContent">
        <div class="top-detail">
          <div class="box">
            <div class="box-heading">
              <div>{{ isEdit ? 'case ' : 'Create a New case' }}</div>
            </div>
            <div class="box-body">
              <div class="box-row" v-if="isEdit">
                <div class="box-col box-col-left">Status</div>
                <div class="box-col box-col-right">
                  <select v-model="singleCase.CaseStatus" class="textbox w-50">
                    <option v-for="status in statusList" :value="status.value">{{ status.text }}</option>
                  </select>
                </div>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div>
              <!-- <div class="box-row" v-if="isEdit">
                <div class="box-col box-col-left">On behalf of</div>
                <div class="box-col box-col-right">
                  <input type="text" class="textbox behalf" v-model="singleCase.onBehalfOf" placeholder="On behalf of" />
                </div>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div> -->
              <div class="box-row">
                <div class="box-col box-col-left">Examinee</div>
                <div class="box-col box-col-right">
                  <div v-if="!isEditName" @click="openAddNameModal" class="parent is-icon full-width-div">
                    <input class="child placeholder-opacity px-3" type="text" disabled
                           placeholder="Please click here to enter the Examinee details"
                           :class="hasError && !validateClaimantName ? 'is-invalid' : ''"/>
                    <div class="text-danger" v-if="hasError && !validateClaimantName">
                      Please enter claimant's name
                    </div>
                  </div>
                  <span v-else :key="nameKey" @click="openAddNameModal" class="pl-2">
                    {{ this.singleCase.ClaimantFullName }}
                  </span>
                  <!-- <div class="text-danger" v-if="hasError && !validateClaimantName" style="position: absolute; z-index: 1; top: 30px;">
                    Please enter claimant's name
                  </div> -->
                </div>
                <AddNameModal ref="addNameModal" @setName="setName"/>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Examinee Salutation</div>
                <div class="box-col box-col-right" >
                  <el-select v-model="singleCase.Salutation" filterable clearable placeholder="Examinee Salutation">
                    <el-option v-for="item in salutationList" :key="item.value" :value="item.value" :label="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Examinee Preferred Name</div>
                <div class="box-col box-col-right" >
                  <el-input class="px-3 w-50" v-model="singleCase.PreferredGivenName" maxlength="100" />
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Date of Birth</div>
                <div class="box-col box-col-right box-col-center">
                  <datepicker
                      format="dd/MM/yyyy"
                      :typeable="true"
                      class="date-of-birth w-50"
                      placeholder="dd/mm/yyyy"
                      v-model="singleCase.DateofBirth"
                      :input-class="hasError && !isValidDateOfBirth ? 'is-invalid' : ''"
                      @input="changeDateOfBirth"></datepicker>
                  <div class="text-danger" v-if="hasError && !isValidDateOfBirth">
                    Examinee's date of birth is invalid
                  </div>
                </div>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Examinee Contact Details</div>
                <div class="box-col box-col-right">
                  <div v-if="!isEditContact" @click="openManageContactDetails" class="parent is-icon full-width-div w-100">
                    <input class="child placeholder-opacity" type="text" disabled
                           placeholder="Please click here to enter contact details"/>
                  </div>
                  <span v-else :key="contactKey" @click="openManageContactDetails">
                    <span v-if="this.singleCase.ClaimantMobile"
                          class='text-bold'>M: </span> {{ this.singleCase.ClaimantMobile }}
                    <span v-if="this.singleCase.ClaimantEmail"
                          class='text-bold'>E: </span> {{ this.singleCase.ClaimantEmail }}
                    <span v-if="this.singleCase.ClaimantPhone1"
                          class='text-bold'>P: </span> {{ this.singleCase.ClaimantPhone1 }}
                    <span v-if="this.singleCase.ClaimantPhone2"
                          class='text-bold'>L: </span> {{ this.singleCase.ClaimantPhone2 }}
                  </span>
                  <div class="is-icon right-float-element w-100" @click="openManageContactDetails">
                  </div>
                  <AddClientContactModal ref="addClientContactModal" :typrProps="'fromcases'"/>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Examinee Address</div>
                <div class="box-col box-col-right">
                  <div v-if="!isEditAddress" class="parent is-icon full-width-div" @click="openManageAddress"
                       :key="addressKey">
                    <input class="child placeholder-opacity w-100" disabled
                           placeholder="Please click here to update claimant's address"/>
                  </div>
                  <span v-else @click="openManageAddress">{{ getFullAddress()}}</span>
                  <div class="is-icon right-float-element" @click="openManageAddress">
                  </div>
                  <AddClientAddressModal @changedAddress="changedAddress" ref="addClientAddressModal"/>
                </div>
              </div>
              <!-- <div class="box-row">
                <div class="box-col box-col-left">Date of Accident/Event</div>
                <div class="box-col box-col-right box-col-center">
                  <div class="w-75">
                    <div class="right-float-element" style="line-height: 40px;">
                      <toggle-button @change="changeOverTime()" class="togglePeriodOfTime" :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true" :value="singleCase.overPeriodofTime"/>  Over a period of time
                    </div>
                    <datepicker
                      :disable="singleCase.overPeriodofTime"
                      format="dd/MM/yyyy"
                      :typeable="true"
                      class="w-50 accient-date"
                      placeholder="dd/mm/yyyy"
                      :disabled="togglePeriodOfTime"
                      :input-class="hasError && !isValidAccidentDate ? 'is-invalid' : ''"
                      v-model="singleCase.accidentDate"
                      @selected="selectAccientDate"
                      @input="changeAccientDate"></datepicker>
                    <div class="text-danger" v-if="hasError && !isValidAccidentDate">
                      Date of Accident/Event is invalid
                    </div>
                  </div>
                </div>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div> -->
              <!-- <div class="box-row">
                <div class="box-col box-col-left">Commencement Date</div>
                <div class="box-col box-col-right box-col-center">
                  <datepicker
                    class="w-50"
                    format="dd/MM/yyyy"
                    :typeable="true"
                    placeholder="dd/mm/yyyy"
                    v-model="singleCase.commencementDate"
                    :input-class="hasError && !validateCommencementDate ? 'is-invalid' : ''"
                    ></datepicker>
                  <div class="text-danger" v-if="hasError && !validateCommencementDate">
                    Please enter commencement date
                  </div>
                </div>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div> -->
              <!-- <div class="box-row" v-if="isEdit">
                <div class="box-col box-col-left">Affected Body Areas</div>
                <div class="box-col box-col-right box-col-center">
                  <vue-tags-input
                    v-model="bodyAreaTag"
                    :tags="bodyAreaTags"
                    placeholder="Please choose"
                    :autocomplete-items="filteredBodyAreaItems"
                    @before-deleting-tag="deleteBodyArea"
                    @focus="openDigram()"
                    />
                </div>
                <div @click="openBodyDiagram" class="center-item">
                  <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3"/>
                </div>
                <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal" />
              </div>
              <div class="box-row" v-if="isEdit">
                <div class="box-col box-col-left">Other Body Areas</div>
                <div class="box-col box-col-right box-col-center">
                  <vue-tags-input
                    v-model="otherBodyAreaTag"
                    :tags="otherBodyAreaTags"
                    placeholder="Add Other Body Areas"
                    @tags-changed="(newTags) => (otherBodyAreaTags = newTags)" />
                </div>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div>
              <div class="box-row" v-if="isEdit">
                <div class="box-col box-col-left">Conditions</div>
                <div class="box-col box-col-right box-col-center">
                  <vue-tags-input
                    ref="conditions"
                    v-model="personConditionTag"
                    :tags="personConditionTags"
                    placeholder="Add Conditions"
                    :add-only-from-autocomplete="true"
                    @before-deleting-tag="deletePersonCondition"
                    :autocomplete-items="filteredPersonConditionsItems"
                    @tags-changed="updateConditions" />
                </div>
                <div class="box-col box-col-right w-auto">
                  &nbsp;
                </div>
              </div> -->
            </div>
          </div>

          <div class="box-row item-right">
            <div>
              <v-btn dark @click="tapSave">{{ isEdit ? 'Update' : 'Save' }}</v-btn>
            </div>
          </div>

          <div class="alert alert-success hidden-element">
            <a class="close" title="close">×</a>
            <b>Success:</b> {{ successMessage }}
          </div>
          <div class="alert alert-danger hidden-element">
            <a class="close" title="close">×</a>
            <b>Error:</b> {{ errorMessage }}
          </div>
          <div class="alert alert-warning hidden-element">
            <a class="close" title="close">×</a>
            <b>Warning:</b> {{ errorMessage }}
          </div>

          <div class="header-title ml-0" style="padding-left=0px" v-if="isEdit">File Summary</div>
          <div class="" v-if="isEdit">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th class="hidden-element">Id</th>
                  <th style="width:20%" class="long-text">File Type</th>
                  <th style="width:25%" class="long-text">File Name</th>
                  <th style="width:10%" class="long-text">Booking ID</th>
                  <th style="width:20%" class="long-text">Uploaded by</th>
                  <th style="width:15%" class="long-text">Status</th>
                  <th style="width:5%" class="long-text"></th>
                  <th style="width:5%" class="long-text"></th>
                </tr>
                </thead>
              </table>
            </div>
            <div class="table-responsive" style="max-height: 200px">
              <table class="table">
                <tbody>
                <tr v-for="(file, index) in allBookingFiles" >
                  <td style="width:20%" class="long-text">{{ file.FileType.FileTypeName }}</td>
                  <td style="width:25%" class="long-text">{{ file.FileName }}</td>
                  <td style="width:10%" class="long-text">{{ file.BookingID }}</td>
                  <td style="width:20%" class="long-text">{{decodeURIComponent(file.UploadedUser.UserName)}}</td>
                  <td style="width:15%" class="long-text">
                    {{ file.FileStatus == 2 ? 'Complete' : getFileStatusNameById(file.FileStatus) }}
                  </td>
                  <td style="width:5%" :class="file.UploadedBy != user.id ? 'img-disable' : ''"
                      @click="deleteFile(file.BookingFileID, index, file.UploadedBy)" class="long-text"><img
                      v-if="file.FileStatus != 1" src="@/assets/images/delete_icon.svg"/></td>
                  <td style="width:5%" class="long-text"><div @click="getFile(file)" class="cursor-pointer"><img
                      src="@/assets/images/eye-icon.svg"/></div></td>
                </tr>
                <tr v-if="allBookingFiles.length == 0">
                  <td>No Files</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="box" v-if="isEdit" style="margin-top: 30px: max-height: 200px">
            <div class="box-heading col-space-between">
              <div>Bookings</div>
              <!-- <div>
                <router-link :to="{path:'/search-specialist',query:{id:singleCase.CaseID}}" class="router-link"><v-btn class="add-icon submit-request" dark>Add Booking</v-btn></router-link>
              </div> -->
            </div>
            <div class="box-body" style="max-height: 250px;overflow: hidden;overflow-y: auto;">
              <div v-if="bookings.length > 0" class="box-row" v-for="(booking, index) in bookings" :key="index">
                <div @click="editBooking(booking.BookingID)" class="list-detail-row is-icon">
                  <div class="box-col" style="width: 90%;">
                    ID: {{ booking.BookingID }} {{ booking.BookingType.BookingTypeName + "," }}
                    {{ formatDate(booking.BookingDateTime, "hh:mm A DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss.ssssss") }}
                    {{ getSpFullName(booking.Specialist) }} {{ booking.Location ? decodeURIComponent(booking.Location.locationName) : '' }}
                  </div>
                  <div class="box-col" style="width: 15%;text-align: end;">
                    {{ getBookingStatusById(booking.BookingStatus) }}
                  </div>
                </div>
              </div>
              <div v-if="bookings.length == 0" class="box-row" style="padding: 10px;">
                No bookings
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Chat/>
    <AdminCaseCreatedModal ref="adminCaseCreatedModal" :clientProps="true"/>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import Navigation from '@/components/Navigation'
import CaseMenu from '@/components/CaseMenu'
import Header from '@/components/Header'
import Chat from '@/components/Chat'
import AddNameModal from '@/components/AddNameModal'
import AdminCaseCreatedModal from '@/components/AdminCaseCreatedModal'
import AddClientContactModal from '@/components/AddClientContactModal'
import AddClientAddressModal from '@/components/AddClientAddressModal'

export default {
  name: 'ManageCase',
  components: {
    Navigation,
    CaseMenu,
    Header,
    Chat,
    AddNameModal,
    AdminCaseCreatedModal,
    AddClientContactModal,
    AddClientAddressModal,
  },
  data() {
    return {
      salutationList: utilities.initSalutation(),
      hasError: false,
      successMessage: '',
      errorMessage: '',

      // Validate Dates
      isValidDateOfBirth: true,
      isValidAccidentDate: true,

      isEdit: true,
      claimFocus: false,
      isEditContact: false,
      isEditAddress: false,
      isEditName: false,
      togglePeriodOfTime: false,
      loaded: false,
      showContent: true,
      bodyAreaTag: "",
      otherBodyAreaTag: "",
      personConditionTag: "",
      placeholder: "Add",
      claimTypes: [],
      // bodyAreas: [],
      // bodyAreaTags: [],
      // otherBodyAreaTags: [],
      // deletedBodyTags: [],
      // personConditions: [],
      // personConditionTags: [],
      // deletedConditionTags: [],
      clientContacts: [],
      client: [],
      bookings: [],
      allBookingFiles: [],
      addedBodyArea: [],
      addedConditions: [],
      cases: [],
      locations: [],
      fileStatus: utilities.getFileStatus(),
      statusList: utilities.getStatus(),
      bookingStatuses: utilities.getBookingStatuses(),
      pagination: utilities.initPagination(),
      singleCase: utilities.initCase(),
      contactKey: 0,
      addressKey: 0,
      nameKey: 0,
      isEditId: 0,
    }
  },
  watch: {
    singleCase: {
      handler(value) {
        if (this.loaded) this.$store.dispatch("setNewObject", value)
      },
      deep: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    validateClaimantName() {
      if (this.singleCase.ClaimantFirstName == '' || this.singleCase.ClaimantSurname == '') {
        return false
      }
      return true
    },

    // validateCommencementDate() {
    //   return this.singleCase.commencementDate == '' ? false : true
    // },


    filteredBodyAreaItems() {
      return this.bodyAreas.filter(i => {
        return i.text.toLowerCase().indexOf(this.bodyAreaTag.toLowerCase()) !== -1;
      });
    },

    filteredPersonConditionsItems() {
      return this.personConditions.filter(i => {
        return i.text.toLowerCase().indexOf(this.personConditionTag.toLowerCase()) !== -1;
      });
    },
  },

  methods: {
    getSpFullName(v) {
      return utilities.getSpecialistFullNameUpper(v)
    },
    changedAddress(v) {
      this.singleCase = v
      this.$forceUpdate()
    },
    getFullAddress(clientCase) {
      return utilities.convertNullToEmpty(this.singleCase.ClaimantAddressLine1) +
          ' ' +
          utilities.convertNullToEmpty(this.singleCase.ClaimantAddressLine2) +
          ' ' +
          utilities.convertNullToEmpty(this.singleCase.ClaimantCity) +
          ' ' +
          utilities.convertNullToEmpty(this.singleCase.ClaimantState) +
          ' ' +
          utilities.convertNullToEmpty(this.singleCase.ClaimantPostcode) +
          ' Australia'
    },
    getContactFullName(v) {
      return utilities.getContactFullNameUpper(v)
    },
    // updateConditions(newTags) {
    //   if(this.$refs.conditions.newTag.length == 0) newTags.pop()
    //   this.personConditionTags = newTags
    // },

    validateDateOfBirth() {
      if (this.singleCase.DateofBirth == '' || !moment($(".date-of-birth input").val(), "DD/MM/YYYY").isValid()) {
        return false
      }
      return true
    },
    // validateAccidentDate() {
    //   if((this.singleCase.accidentDate == '' || !moment($(".accient-date input").val(), "DD/MM/YYYY").isValid()) && !this.singleCase.overPeriodofTime) {
    //     return false
    //   }
    //   return true
    // },
    validateAllDates() {
      if (!this.validateDateOfBirth()) return false
      else return true
    },
    changeDateOfBirth() {
      setTimeout(() => {
        this.isValidDateOfBirth = this.validateDateOfBirth()
      }, 200)
    },
    // changeAccientDate() {
    //   setTimeout(() => {
    //     this.isValidAccidentDate = this.validateAccidentDate()
    //   }, 200)
    // },

    // selectAccientDate() {
    //   this.singleCase.overPeriodofTime = false
    // },

    getFileStatusNameById(id) {
      if(id == 2) {
        return 'Complete'
      } else if (id == 3) {
        return 'For Review'
      }
      if (id == 0 || id == 1) {
        return this.fileStatus.find((x) => x.id == id).name
      }
      return ''
    },

    getClaimantTypeName(id) {
      var type = ''
      if (id) {
        type = this.claimTypes.find((x) => x.id == id).name
      }
      return type
    },

    enableEditCase(status) {
      this.isEditId += 1
      this.isEdit = status;
    },

    getBookingStatusById(id) {
      if (id) {
        var status = this.bookingStatuses.find((x) => x.id == id)
        if (status) {
          return status.name
        }
      }
      return ""
    },

    changeOverTime() {
      this.singleCase.overPeriodofTime = !this.singleCase.overPeriodofTime
      if (this.singleCase.overPeriodofTime) {
        this.singleCase.accidentDate = ""
      }
      //this.isValidAccidentDate = this.validateAccidentDate()
    },

    formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      if (date) {
        return utilities.formatDate(date, format, currentFormat)
      }
      return ""
    },

    // deleteBodyArea(obj) {
    //   this.deletedBodyTags.push(obj.tag)
    //   this.bodyAreaTags.splice(obj.index, 1);
    // },

    // deletePersonCondition(obj) {
    //   this.deletedConditionTags.push(obj.tag)
    //   this.personConditionTags.splice(obj.index, 1);
    // },

    getPath(filepath) {
      return utilities.getFileFromPath(filepath.replace("/BookingFiles", "/files"))
    },

    editBooking(bookingId) {
      this.$router.push({path: '/edit-booking', query: {id: bookingId}}).catch((err) => {
      })
    },

    // openBodyDiagram() {
    //   this.$refs.addBodyDiagramModal.handleModal()
    //   this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreas
    //   this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreaTags)
    //   this.$refs.addBodyDiagramModal.handleClick()
    // },

    // setBodyArea(addedBodyAreas) {
    //   this.bodyAreaTags = []
    //   this.bodyAreaTags = addedBodyAreas
    // },

    setName(object) {
      this.singleCase.ClaimantFirstName = object.firstName
      this.singleCase.ClaimantGivenNames = object.middleName
      this.singleCase.ClaimantSurname = object.surname
      this.singleCase.ClaimantFullName = utilities.getClaimantFullNameUpper(this.singleCase)
      if (this.singleCase.ClaimantFullName != "") {
        this.isEditName = true
      } else {
        this.isEditName = false
      }

      this.$forceUpdate()
    },

    // deleteBodyAreaItems(items) {
    //   items.map((x) => {
    //     this.deletedBodyTags.push(x.tag)
    //   })
    // },

    async tapSave() {
      console.log({...this.singleCase})
      if ( !this.validateClaimantName
          || !this.validateAllDates()) {
        this.hasError = true
        return
      } else {
        this.hasError = false
      }

      var params = {
        ClientID: this.user.clientId,
        ClaimantFirstName: this.singleCase.ClaimantFirstName.trim(),
        ClaimantGivenNames: this.singleCase.ClaimantGivenNames,
        ClaimantSurname: this.singleCase.ClaimantSurname.trim(),
        // CommencementDate: moment(this.singleCase.commencementDate).format('YYYY-MM-DD'),
        DateofBirth: moment(this.singleCase.DateofBirth).format('YYYY-MM-DD'),
        PreferredGivenName: this.singleCase.PreferredGivenName,
        Salutation: this.singleCase.Salutation,
        ClaimantPhone1: this.singleCase.ClaimantPhone1 || undefined,
        ClaimantPhone2: this.singleCase.ClaimantPhone2 || undefined,
        ClaimantMobile: this.singleCase.ClaimantMobile || undefined,
        ClaimantEmail: this.singleCase.ClaimantEmail || undefined,
        ClaimantAddressLine1: this.singleCase.ClaimantAddressLine1,
        ClaimantAddressLine2: this.singleCase.ClaimantAddressLine2,
        ClaimantCity: this.singleCase.ClaimantCity,
        ClaimantState: this.singleCase.ClaimantState,
        ClaimantPostcode: this.singleCase.ClaimantPostcode,
        ClaimantCountry: 'AU',
        CaseStatus: this.singleCase.CaseStatus,
      }

      if (!this.singleCase.CaseID) {
        this.$store.dispatch('loading/setLoadComponent', true)
        var callback = (response) => {
          this.singleCase.CaseID = response
          if (response !== undefined) {
            this.$refs.adminCaseCreatedModal.setCaseRefe(this.singleCase.CaseReference)
            this.$refs.adminCaseCreatedModal.handleModal()
          }
        }
        const obj = {...params}
        for (let key in obj) {
          if (obj[key] === null || obj[key] === '') {
            delete obj[key];
          }
        }
        await utilities.postCase(obj, callback)
        utilities.clearChangingObject()
        this.$store.dispatch('loading/setLoadComponent', false)
      } else {

        this.$store.dispatch('loading/setLoadComponent', true)
        var callback = (response) => {

        }
        const obj = {...params}
        for (let key in obj) {
          if (obj[key] === null || obj[key] === '') {
            delete obj[key];
          }
        }

        await utilities.putCase(this.singleCase.CaseID, obj, callback)
        utilities.clearChangingObject()
        this.$store.dispatch('loading/setLoadComponent', false)
      }
    },

    setDetails() {
      if (this.singleCase.caseStatus == '') {
        this.singleCase.caseStatus = 1
      }
      if (this.singleCase.ClaimantPhone1 || this.singleCase.ClaimantMobile || this.singleCase.ClaimantPhone2 || this.singleCase.ClaimantEmail) {
        this.isEditContact = true
      } else {
        this.isEditContact = false
      }

      if (this.singleCase.ClaimantAddressLine1 || this.singleCase.ClaimantAddressLine2 || this.singleCase.ClaimantCity) {
        this.isEditAddress = true
        this.singleCase.claimantCountry = ""
      } else {
        this.isEditAddress = false
      }

      if (this.singleCase.ClaimantFullName) {
        this.isEditName = true
      } else {
        this.isEditName = false
      }
    },

    openAddNameModal() {
      if (this.isEditName) {
        this.$refs.addNameModal.editFullName(this.singleCase.ClaimantFirstName, this.singleCase.ClaimantGivenNames, this.singleCase.ClaimantSurname)
      }
      this.$refs.addNameModal.handleModal();
    },

    openManageContactDetails() {
      this.$refs.addClientContactModal.singleCase = this.singleCase
      this.$refs.addClientContactModal.booking = this.booking
      this.$refs.addClientContactModal.setCaseContactDetails()
      this.$refs.addClientContactModal.handleModal()
    },

    openManageAddress() {
      this.$refs.addClientAddressModal.singleCase = this.singleCase
      this.$refs.addClientAddressModal.isClient = false
      this.$refs.addClientAddressModal.handleModal()
      this.$refs.addClientAddressModal.setCaseAddressDetails()
    },

    async deleteFile(fileId, index, uploadedBy) {
      if (uploadedBy != this.user.id) {
        return
      }
      this.$confirm({
        content: 'Are you sure you want to delete this file?',
        onConfirm: async () => {
          this.$store.dispatch('loading/setLoadComponent', true)
          var params = {
            userId: this.user.id,
            userName: this.user.name,
            id: fileId,
          }

          var result = await utilities.deleteBookingFileById(params)
          if (result) {
            this.allBookingFiles.splice(index, 1)
          }
          this.$store.dispatch('loading/setLoadComponent', false)
        }
      })
    },

    getLocationById(id) {
      var value = ''
      if (id) {
        value = this.locations.find((x) => x.id == id).fullLocation
      }
      return value
    },
    getFile(file) {
      const params = {
        filetype: "bf",
        fn: file.FileName,
        id: file.BookingID
      }
      utilities.getDownloadFileUrlNew(params).then(res => {
        let a = document.createElement('a');
        let fileName = file.fileName
        a.target = '_blank'
        a.download = fileName;
        a.href = res
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(res);
        document.body.removeChild(a);
      })
    },

    async loadData(caseId) {
      const apiArr = [utilities.getClientContacts(this.user.clientId), utilities.getCaseByCaseId(caseId), utilities.getLocations()]
      const r = await Promise.all(apiArr)
      this.clientContacts = r[0]
      this.singleCase = r[1]
      this.$store.dispatch("setOriginalObject", this.singleCase)
      this.$store.dispatch("setNewObject", this.singleCase)

      // if (this.singleCase.bodyAreas.length > 0) {
      //   this.addedBodyArea = _.cloneDeep(this.singleCase.bodyAreas)
      //   this.bodyAreaTags = utilities.getAutoCompleteBodyAreaTags(this.singleCase.bodyAreas)
      // }
      //
      // if (this.singleCase.bodyAreaOther.length > 0) {
      //   var items = this.singleCase.bodyAreaOther.split(',');
      //   this.otherBodyAreaTags = utilities.getAutoCompleteOtherBodyAreaTags(items)
      // }
      //
      // if (this.singleCase.personCondition.length > 0) {
      //   this.addedConditions = _.cloneDeep(this.singleCase.personCondition)
      //   this.personConditionTags = utilities.getAutoCompleteTags(this.singleCase.personCondition)
      // }

      this.locations = r[2]
      this.bookings = r[1].Bookings
      let arr = []
      this.bookings.forEach((booking) => {
        booking.BookingFiles.forEach(file => {
          this.allBookingFiles.push(file)
        })
      });

      console.log(this.allBookingFiles)
      this.setDetails()
    },
  },

  async beforeMount() {
    this.$store.dispatch('loading/setLoadComponent', true)
    $('body>.tooltip').remove()
    // var params = {
    //   clientId: this.user.clientId,
    //   userId: this.user.id
    // }
    this.singleCase.CaseID = this.$route.query.id !== undefined ? this.$route.query.id : ''
    if (this.singleCase.CaseID !== '') {
      await this.loadData(this.singleCase.CaseID)
      this.enableEditCase(true)
    } else {
      this.enableEditCase(false)
    }
    const apiArr = [utilities.getClientById(this.user.clientId), utilities.getClaimTypes()]
    const r = await Promise.all(apiArr)
    this.client = r[0]
    this.claimTypes = r[1]
    this.$store.dispatch('loading/setLoadComponent', false)
    this.loaded = true
    this.isValidDateOfBirth = this.validateDateOfBirth()
    // this.isValidAccidentDate = this.validateAccidentDate()

    $('.referance').keydown((e) => {
      var code = e.keyCode || e.which;
      if (code === 9) {
        this.openAddNameModal()
      }
    });

    $('.behalf').keydown((e) => {
      var code = e.keyCode || e.which;
      if (code === 9) {
        this.openAddNameModal()
      }
    });

    $('.date-of-birth').keydown((e) => {
      var code = e.keyCode || e.which;
      if (code === 9) {
        this.openManageContactDetails()
      }
    });

  },

  mounted() {
    $('[data-toggle="tooltip"]').tooltip()
  },
}
</script>
